import { onMounted, onBeforeUnmount } from 'vue';
import { useAppStore } from '../stores/appStore';

export function useGuestlineListener(guestlineUrl: string) {
  const appStore = useAppStore();

  const generateGuestlineUrl = (el: HTMLElement) => {
    const url = new URL(guestlineUrl);
    Object.entries(el.dataset).forEach(([key, value]) => {
      if (value === undefined) return;
      if (key === 'promocode') url.searchParams.append('promoCode', value);
      else if (key !== 'guestline') url.searchParams.append(key, value);
    });
    appStore.setGuestlineActiveUrl(url.toString());
  };

  const onBodyClick = (e: MouseEvent) => {
    const target = e.target as Element | null;
    const guestlineEl = target?.closest<HTMLElement>('[data-guestline]');
    if (guestlineEl) {
      generateGuestlineUrl(guestlineEl);
    }
  };

  onMounted(() => {
    document.addEventListener('click', onBodyClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', onBodyClick);
  });
}
